import { Box } from '@mui/material';
import React, { forwardRef } from 'react';

import { InputProps } from './Input.interface';
import { InputTextLabel, ValidationTextField } from './Input.styled';

export const Input = forwardRef((props: InputProps, ref) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange(e.target.value);
  };

  return (
    <Box>
      <InputTextLabel status={props.status}>{props.label}</InputTextLabel>
      <ValidationTextField
        ref={ref}
        onChange={handleChange}
        defaultValue={props.value}
        status={props.status}
        aria-label={props.label}
      />
    </Box>
  );
});
